import * as React from "react";
import Axios from "axios";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Button,
  TextField,
  Link,
} from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { useTranslation } from "react-i18next";
import { AddSession } from "../config/SessionController";
import BigCLoading from "./Layout/Loading/Loading";

import "./Signin.css";
async function loginUser(PassCode) {
  try {
    let result = await Axios.get(
      `${process.env.REACT_APP_BACKEND_DOMAIN_API}/game_web/user/login/${PassCode}`,
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY,
        },
      }
    );
    return result.data;
  } catch (error) {
    return { message: "Your Passport ID incorrect" };
  }
}

export default function RegisterSignin() {
  const { t } = useTranslation();
  const [isLang, setIsLang] = React.useState("en");
  let { lang } = useParams();
  const { i18n } = useTranslation();

  const [dataPassCode, setDataPassCode] = React.useState("");
  const [isError, setIsError] = React.useState(false);
  const [submitted, setSubmitted] = React.useState(false);

  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    async function fetchData() {
      await i18n.changeLanguage(lang);
      await setIsLang(lang);
      await setLoading(false);
    }
    fetchData();
  }, []);

  const handleChangeLang = (lang) => {
    window.location.href = `/${lang}/signin`;
  };
  const handleRegister = (lang) => {
    window.location.href = `/${lang}/register`;
  };

  

  const handleLogin = async (e) => {
    e.preventDefault();
    //const myFile = formRef.current;
    if (!dataPassCode) {
      setIsError(true);
      Swal.fire({
        icon: "error",
        title: "Input Failed",
      });
    } else {
      const response = await loginUser(dataPassCode);
      //console.log(response);
      if (response.status === "success") {
        const user = {
          userId: response.data.id,
          codeId: response.data.code_id,
          displayName: response.data.first_name + " " + response.data.last_name,
          passport: response.data.passport,
          accessToken: response.data.access_token,
        };
        await AddSession(user);
        setIsError(false);
        setSubmitted(true);
        window.location.href = `/${lang}/Lobby`;
      } else {
        //setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Login Failed",
          text: response.message,
        }).then(() => {
          setSubmitted(false);
        });
      }
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    const value = e.target.value;
    setDataPassCode(value);
  };

  return (
    <>
      {loading === true ? (
        <BigCLoading />
      ) : (
        <Box sx={{ minHeight: 800, width: "100%", boxShadow: "none" }}>
          <Box
            sx={{
              m: 2,
            }}
          >
            <Grid container spacing={1}>
              <Grid item sm={12} xs={12}>
                <Box className="signin-box-game">
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12}>
                      <Box className="main-box-len">
                        <Box className="box-btn-len">
                          <Button
                            className={
                              lang === "en"
                                ? "active radiusLeft"
                                : "radiusLeft"
                            }
                            sx={{ color: "#fff", float: "left" }}
                            onClick={(e) => handleChangeLang("en")}
                          >
                            EN
                          </Button>
                          <Button
                            className={
                              lang === "cn"
                                ? "active radiusRight"
                                : "radiusRight"
                            }
                            sx={{ color: "#fff" }}
                            onClick={(e) => handleChangeLang("cn")}
                          >
                            中文
                          </Button>
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item sm={12} xs={12}>
                      <Card className="signin-card-game">
                        <CardContent
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            width: "100%",
                          }}
                        >
                          <Box className="signin-box-game-list">
                            <Box
                              sx={{ display: "flex", justifyContent: "center" }}
                              className="root-logo"
                            >
                              <Box
                                component="img"
                                src="/img/logo-lucklanding.png"
                                className="logo-biggame"
                              />
                            </Box>

                            <Box className="signin-field-game">
                              <Box className="signin-textfield-game">
                                <TextField
                                  required
                                  id="pass_code"
                                  label="Passport ID"
                                  inputProps={{
                                    min: 0,
                                    style: {
                                      textAlign: "center",
                                      backgroundColor: "#fff",
                                      borderRadius: "5px",
                                      width: "190px",
                                      padding: "16px 0",
                                    },
                                  }}
                                  sx={{ border: "none" }}
                                  value={dataPassCode}
                                  error={!dataPassCode && isError}
                                  onChange={(e) => handleChange(e, "pass_code")}
                                />
                              </Box>
                            </Box>
                            <Box className="signin-button-game">
                              <Box className="signin-btn-start-game">
                                <Button
                                  sx={{ color: "#fff" }}
                                  onClick={(e) => handleLogin(e)}
                                  endIcon={<PlayArrowIcon />}
                                  disabled={submitted}
                                >
                                  {t("btn_Login")}
                                </Button>
                              </Box>
                            </Box>
                            
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      )}
    </>
  );
}
